export default "<p>\n  graficas1 works!\n</p>\n";